import ExitProcess from './ExitProcess';

export default ExitProcess;
